export default __webpack_public_path__ + "static/media/all-in-nft.10029c09.png";